<template>
  <div class="container">
    <van-sticky>
      <van-nav-bar style="position:sticky" @click-left="goback" left-arrow fixed title="文章详情">
      </van-nav-bar>
    </van-sticky>
    <div class="content">
      <div v-if="article.type=='link'" class="link">
        <iframe :src="article.articleLink" frameborder="0" width="100%" height="800px"></iframe>
      </div>
      <div v-if="article.type=='custom'" class="custom richTextParsing">
        <div class="title">{{ article.title }}</div>
        <div  v-html="article.details"></div>
      </div>
    </div>
    <div class="fixed-bottom">
      <div class="eye">
        &nbsp;<img class="icon" src="../../../assets/eye-icon.png" alt="" />
        {{ article.readNum }}次
      </div>
      <div class="share" @click="showShareDialog = true">
        &nbsp;<img class="icon" src="../../../assets/share-icon.png" alt="" />
        分享
      </div>
    </div>
    <van-overlay :show="showShareDialog" @click="show = false">
      <div class="shareImgDiv">
        <img
          class="shareImg"
          src="https://xianglin003.oss-cn-beijing.aliyuncs.com/active_images/guideLine.png"
          alt=""
        />
      </div>
      <div class="shareDesc">
        <div>
          <span>点击右上角按钮</span>
          <span>立即分享到朋友圈</span>
        </div>
      </div>
      <div class="shareKnowBtn">
        <button @click="showShareDialog = false">朕知道了</button>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  getArticleDetails,
  createOperateWithArticle,
} from "../../../api/center";
import { commomShare } from "@/utils/share";
import store from "@/store";
import { Toast } from "vant";
export default {
  data() {
    return {
      id: "",
      article: {},
      showShareDialog: false,
      nodeUserId: null,
      cateId:null,
      defaultImg: "https://xianglin003.oss-cn-beijing.aliyuncs.com/active_images/blacklogo.jpg",
      centerStation: false,

    };
  },
  created() {
    document.title="站长中心"
    this.centerStation = JSON.parse(sessionStorage.getItem("centerStation"))
    console.log("nodeUserId:",this.$route.query.nodeUserId)
    if (this.$route.query.nodeUserId) {
      this.nodeUserId = this.$route.query.nodeUserId;
    } else {
      this.nodeUserId = store.state.user.userId;
    }
    console.log("赋值之后this.nodeUserId:",this.nodeUserId)
    if (this.$route.query.articleId) {
      this.id = this.$route.query.articleId;
    } else {
      this.id = this.$route.query.id;
    }
    // 需要拼接路由跳转
    
    if(!this.$route.query.nodeUserId||!this.$route.query.articleId) {
      // 是否是分享的详情链接 是分类跳转的
      if(this.$route.query.cateId&&!this.centerStation) {
        sessionStorage.setItem("noShareCome",true)
      }
      console.log("赋值之后this.nodeUserId:",this.nodeUserId)
      this.$router.replace({
        path: "/stationCenter/detail",
        query: {
          nodeUserId: this.nodeUserId,
          articleId: this.id,
        }
      })
    } else {
      // debugger
      if(!JSON.parse(sessionStorage.getItem("noShareCome")))
        sessionStorage.setItem("noShareCome",false)
      }
    console.log("endthis.nodeUserId:",this.nodeUserId)
    
    
  },
  mounted() {
    this.getArticle();
    this.createOperateWithArticle();
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
    });
  },
  methods: {
    createOperateWithArticle() {
      // 增加阅读数量
      let params = {
        inviterUserId: this.nodeUserId,
        source:'article',
        operateType: "read",
        articleId: this.id,
      };
      createOperateWithArticle(params,this.id).then((res) => {
      });
    },
    getArticle() {
      let params = {
        id: this.id,
      };
      getArticleDetails(params).then((res) => {
        if(res.code == 200) {
          this.article = res.data;
          this.shareInfo();
          this.cateId=res.data.cateId
        }
      });
    },
    goback() {
      // 是站长 back() ; 否则 home
      if(this.centerStation) {
        this.$router.go(-2);
      } else {
        if(JSON.parse(sessionStorage.getItem("noShareCome"))) {
          this.$router.go(-2);
        } else {
          this.$router.push({
            path: "/stationCenter/centerHome",
            query: {
              nodeUserId: this.nodeUserId,
            }
          });

        }
      }

    },
    shareInfo() {
      // 分享
      let articleTitle = this.article.title;
      let title = articleTitle;
      let desc = this.article.describes;
      // let link = `${window.location.href.split("?")[0]}?nodeUserId=${
      //   this.nodeUserId
      // }&articleId=${this.id}`;
      let link = window.location.href;
      console.log("detail-link:",link)
      console.log("detail-nodeUserId:",this.nodeUserId)
      console.log("detail-articleid:",this.id)
         // 增加阅读数量
    
      commomShare(title, link, this.article.coverFile?this.article.coverFile:this.defaultImg, desc,
        function(res) {
          if(res) {
            Toast.loading({
              message: "加载中...",
              forbidClick: false,
            });
          }
        });
    },
  },
}
</script>
<style>
  /* @import url(); 引入css类 */
  .richTextParsing img {
    max-width: 100%!important;
    height: auto!important;
  }
</style>
<style lang="less" scoped>
.title {
  font-family: PingFangSC-Regular;
  color: #242424;
  font-size: 18px;
  font-size: 18px;
  color: #242424;
  margin-bottom: 20px;
}
.content {
  //margin-top: 46px;
  .custom{
    margin:0 20px;
    padding:20px 0 50px 0;
  }
}
.fixed-bottom {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  box-shadow: 0 -10px 10px 0 rgba(160, 160, 160, 0.07);
  background-color: #fff;
  color: #4b978f;
  font-size: 12.3px;
  .eye {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  .share {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 12.5px;
    height: 10px;
    margin-right: 10px;
  }
}
.shareImgDiv {
  overflow: hidden;
}
.shareImg {
  margin: 20px 20px 0 0;
  float: right;
  width: 46%;
}
.shareDesc {
  margin-top: 6%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
  flex-direction: column;
  line-height: 40px;
  div {
    display: flex;
    flex-direction: column;
  }
}
.shareKnowBtn {
  display: flex;
  justify-content: center;
  margin-top: 30%;
}
.shareKnowBtn button {
  background: rgba(0, 0, 0, 0);
  width: 55%;
  height: 54px;
  border: 1px dashed #fff;
  color: #fff;
  font-size: 20px;
}
</style>
